
import { getActions } from '../sagas';

/**
 * Command `map.setCenter`
 *
 * @typedef {Object} MultSceneForApp~Map~Commands~SetCenter
 * @property {string} command - name of command, has value `map.setCenter`
 * @property {Number} x - x coordinate value of center
 * @property {Number} y - y coordinate value of center
 * @property {Number} zoom - zoom level
 */
function setCenter(params, dispatch) {
    const addCommand = getActions(dispatch).addCommand;
    addCommand('SET_CENTER', {x: params.x, y: params.y, zoom: params.zoom});
}

export default {
    name: 'map.setCenter',
    execute: setCenter
}
